<template>
    <div style="display: inline-block;">
        <Checkbox v-model="text" :value="value" :disabled="readonly" style="vertical-align: middle;" @click="click" @change="change" />
        <label for="tw-checkbox" style="padding: 0 5px;font-size: 12px;">
            <slot>复选框</slot>
        </label>
    </div>
</template>

<script>
import { computed } from 'vue'
import Checkbox from 'primevue/checkbox';

export default {
    name: 'tw-checkbox',
    components: {
        Checkbox
    },
    setup(props, context) {
        const text = computed({
            get() {
                return (props.modelValue === null || props.modelValue === undefined) ? [] : props.modelValue
            },
            set(value){
                context.emit('update:modelValue', value)
            }
        })

        const click = () => {
            context.emit('click')
        }

        const change = () => {
            context.emit('change')
        }

        return {
            text,
            click,
            change
        }
    },
    props: {
        modelValue: null,
        value: String,
        readonly: Boolean
    }
}
</script>
